import React, { useEffect, useState } from "react";
import { useLanguage } from "../contexts/LanguageContext";

const NODES = [
  "Start",
  "Guided",
  "Manual",
  "Session",
  "Analytics",
  "Simulation",
  "Personal",
  "Codes",
  "Reviews",
  "Support",
];

export const ProgressLine = () => {
  const { t } = useLanguage();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const total = h.scrollHeight - h.clientHeight;
      const ratio = total > 0 ? Math.min(1, Math.max(0, h.scrollTop / total)) : 0;
      setProgress(ratio);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const activeIndex = Math.min(NODES.length - 1, Math.floor(progress * NODES.length));

  return (
    <>
      {/* Desktop horizontal */}
      <div className="hidden md:block sticky top-[88px] z-30 px-10 lg:px-16 pointer-events-none" data-testid="progress-line-desktop">
        <div className="max-w-[1440px] mx-auto">
          <div className="glass rounded-full px-5 py-2.5 inline-flex items-center gap-3 pointer-events-auto">
            <span className="font-mono text-[9px] tracking-[0.22em] uppercase text-[#A9824A]">
              {t("progressLabel")}
            </span>
            <div className="flex items-center gap-1.5">
              {NODES.map((n, i) => (
                <div
                  key={n}
                  className={`h-[2.5px] rounded-full transition-all duration-700 ease-out ${
                    i <= activeIndex ? "bg-[#D7B56D] w-6" : "bg-[#D8DCE2]/12 w-3"
                  }`}
                />
              ))}
            </div>
            <span className="font-mono text-[10px] text-[#76D9E8]">
              {String(activeIndex + 1).padStart(2, "0")} <span className="text-[#D8DCE2]/40">/ {NODES.length}</span>
            </span>
          </div>
        </div>
      </div>

      {/* Mobile bottom capsule */}
      <div className="md:hidden fixed bottom-20 left-1/2 -translate-x-1/2 z-30 pointer-events-none" data-testid="progress-line-mobile">
        <div className="glass rounded-full px-4 py-2 inline-flex items-center gap-2 pointer-events-auto">
          <span className="status-dot w-1.5 h-1.5 rounded-full bg-[#76D9E8]" />
          <span className="font-mono text-[9px] tracking-[0.18em] uppercase text-[#D7B56D]">
            {t("progressLabel")} · {String(activeIndex + 1).padStart(2, "0")}/{NODES.length}
          </span>
        </div>
      </div>
    </>
  );
};
